// league-preference.js -- persisted league picks. Single job: read/write one
// validated league value per storage key. Reads SUPPORTED_LEAGUES and
// platform.js storage; writes only the keys exported here.
//
// Two keys, two questions (UI critique bug-fix batch item E, decision D1):
//   LAST_LEAGUE_KEY -- the user's last-picked ENTRY league (the AddSlipSheet pill,
//     the parse hint sent to /api/claude-vision). readLastLeague fails closed to
//     the registry's first entry (SUPPORTED_LEAGUES[0]), owned by the registry.
//   HOME_LEAGUE_KEY -- the Home schedule chip. Kept separate so browsing scores
//     never changes what the next import assumes. readLeaguePref returns null
//     when nothing valid is stored and the caller owns its fallback (Home applies
//     normalizeLeague -> mlb, spec §6).
// Every read validates against SUPPORTED_LEAGUES, so a stale, unknown or poisoned
// stored value is never rendered and never reaches an API. Storage failures are
// handled (warning-level) inside platform.js.
import { SUPPORTED_LEAGUES } from './constants';
import { storageGet, storageSet } from './platform';

export const LAST_LEAGUE_KEY = 'sliptrack_last_league';
export const HOME_LEAGUE_KEY = 'sliptrack_home_league';
const DEFAULT_LEAGUE = SUPPORTED_LEAGUES[0];

export function readLeaguePref(key) {
  const stored = storageGet(key);
  return SUPPORTED_LEAGUES.includes(stored) ? stored : null;
}

export function writeLeaguePref(key, league) {
  if (!SUPPORTED_LEAGUES.includes(league)) return false;
  return storageSet(key, league) === true;
}

export function readLastLeague() {
  return readLeaguePref(LAST_LEAGUE_KEY) ?? DEFAULT_LEAGUE;
}

export function writeLastLeague(league) {
  return writeLeaguePref(LAST_LEAGUE_KEY, league);
}
